import Chip from '@mui/material/Chip';
import {
  formatDuration,
  useProposalEngagement,
  viewsLabel,
} from '../../../../data-access/proposalEngagement';

interface ProposalEngagementChipProps {
  appointmentProposalId: string;
}

const ProposalEngagementChip: React.FC<ProposalEngagementChipProps> = ({
  appointmentProposalId,
}) => {
  const { proposalEngagements } = useProposalEngagement();
  const engagement = proposalEngagements.find(
    (e) => e.proposalId === appointmentProposalId
  );

  const metrics =
    engagement &&
    (engagement.totalPageViews > 0 || engagement.grandTotalMinutes > 0)
      ? `: ${viewsLabel(engagement.totalPageViews)} · ${formatDuration(
          engagement.grandTotalMinutes
        )}`
      : '';

  return (
    <Chip
      color={'softGold'}
      size={'small'}
      label={`Proposal shared${metrics}`}
    />
  );
};

export default ProposalEngagementChip;
